export default __webpack_public_path__ + "static/media/Group9203.5af71fd7.svg";